import { render, staticRenderFns } from "./docenteDocumentos.vue?vue&type=template&id=1c3d1204"
import script from "./docenteDocumentos.vue?vue&type=script&lang=js"
export * from "./docenteDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports